import service from "@irati/utils/tracking/index"

const tracking = {
  view: (page: string, data?: object) => {
    service.trackPlatformEvent(`platform_view_${page}`, data)
  },
  click: (item: string, data: object) => {
    service.trackPlatformEvent(`platform_click_${item}`, data)
  },
  dismiss: (type: string, source: string, data: object) => {
    service.trackPlatformEvent("platform_dismiss", {...data, type, source})
  },
  openLiveChat: () => {
    service.trackPlatformEvent("platform_opened_live_chat", {})
  },
  clickHeaderHomeButton: (data: object) => {
    service.trackPlatformEvent("platform_click_header_home", data)
  },
  clickHeaderMyAccount: (data: object) => {
    service.trackPlatformEvent("platform_click_header_myaccount", data)
  },
  notificationOptInSkipped: () => {
    service.trackPlatformEvent("platform_notifications_optin_skipped", {})
  },
  notificationOptInStarted: () => {
    service.trackPlatformEvent("platform_notifications_optin_started", {})
  },
  notificationOptInCompleted: (status: string) => {
    service.trackPlatformEvent("platform_notifications_optin_completed", {status})
  },
  notificationOptInSeen: () => {
    service.trackPlatformEvent("platform_notifications_optin_seen", {})
  },
  loadingSeen: () => {
    service.trackPlatformEvent("platform_loading_seen", {})
  },
  loadingCompleted: () => {
    service.trackPlatformEvent("platform_loading_completed", {})
  },
  onBoarding: (step: string) => {
    service.trackPlatformEvent("onboarding_view_step", {step})
  },
  onBoardingComplete: () => {
    service.trackPlatformEvent("onboarding_complete", {})
  },
  navigationClick: (data: object) => {
    service.trackPlatformEvent("navigation_button_click", data)
  }
}

export default tracking
